import { useState } from 'react';

import SharedAsset from '@zenbusiness/zui/SharedAsset';
import Stack from '@zenbusiness/zui/Stack';
import { useTheme } from '@zenbusiness/zui/styles';
import Text from '@zenbusiness/zui/Text';
import Tooltip from '@zenbusiness/zui/Tooltip';
import PropTypes from 'prop-types';

import { CaptionDesc, IconButtonStyled } from './TransferTypeToolTip.styles';

export default function TransferTypeToolTip({ title, description }) {
  const { palette } = useTheme();
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <Tooltip
      aria-label="transfer-type-tooltip"
      componentsProps={{
        tooltip: {
          sx: {
            bgcolor: palette.fixed.black,
            borderRadius: '12px',
            padding: 0,
            width: '320px'
          }
        }
      }}
      onClose={() => setShowTooltip(false)}
      onOpen={() => setShowTooltip(true)}
      open={showTooltip}
      title={
        <Stack
          pb="20px"
          pt="16px"
          px="16px"
          spacing="4px"
        >
          <Text
            align="left"
            color="white"
            size="md"
            weight="medium"
          >
            {title}
          </Text>
          <CaptionDesc
            align="left"
            color="white"
            size="sm"
          >
            {description}
          </CaptionDesc>
        </Stack>
      }
    >
      <Stack
        onClick={() => setShowTooltip(!showTooltip)}
        sx={{
          cursor: 'pointer'
        }}
      >
        <IconButtonStyled
          aria-label="transfer-type-tooltip-btn"
          size="small"
          variant="text"
        >
          <SharedAsset
            alt=""
            color="text.blue"
            src="/s2/icon/c-info-outline.svg"
            width={15}
          />
        </IconButtonStyled>
      </Stack>
    </Tooltip>
  );
}

TransferTypeToolTip.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string
};
